import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { adminService } from "@/api/services/adminService"; // Adjust the path as needed

// Define initial state
const initialState = {
    tenants: [] as { id: string; name: string }[],
    loading: false,
    error: null as string | null,
};

// Async thunk to fetch tenants
export const fetchTenants = createAsyncThunk(
    "tenants/fetchTenants",
    async (_, { rejectWithValue }) => {
        try {
            const response = await adminService.tenantAll();
            
            console.log("Full API Response:", response);

            const tenants = response.data; // ✅ Correct extraction
            console.log("Extracted Tenants:", tenants);

            if (!Array.isArray(tenants)) {
                console.error("Invalid response structure. Expected an array, got:", tenants);
                throw new Error("Invalid response structure");
            }

            return tenants?.map(({ id, name }) => ({ id, name }));
        } catch (error) {
            console.error("Error fetching tenants:", error);
            return rejectWithValue("Failed to fetch tenants");
        }
    }
);

const tenantSlice = createSlice({
    name: "tenants",
    initialState,
    reducers: {
        resetTenantState: () => initialState, // ✅ Moved to reducers
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTenants.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTenants.fulfilled, (state, action) => {
                state.loading = false;
                console.log("Redux Payload (Filtered):", action.payload);
                state.tenants = action.payload;
            })
            .addCase(fetchTenants.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export const { resetTenantState } = tenantSlice.actions; // ✅ Export the action
export default tenantSlice.reducer;
